import * as yup from "yup";

export const passwordSchema = yup.string().min(8, "Password field must contain atleast 8 characters").required();
// export const multiSelectSchema = yup.array().min(1).required();
export const nameSchema = yup
    .string()
    .min(1, "This field should not be empty")
    .max(50)
    .matches(/^\S+$/, "Spaces are not allowed")
    .required();